import { toast } from 'sonner'

// export const loadingToast = toast.loading("Processing... ⏳",{className:"mt-10"});
export const successToast = (message: string) => {
    toast.success(message, { className: 'mt-10', closeButton: true, id: Math.random().toString() })
}

export const errorToast = (error: string) => {
    toast.error(error, { className: 'mt-10', closeButton: true, id: Math.random().toString() })
}
